<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    График платежей
                </h3>
            </div>
            <aside class="col-lg-4">
                <MenuComponent/>
            </aside>
            <div class="col-lg-8" v-if="session.newType == 1 && session.accPayGrafik == 0">
                <h3>Вам запрещен просмотр графика платежей</h3>
            </div>
            <div class="col-lg-8" v-else-if="!session.kredit">
                <h3>Кредитные условия не предоставляются</h3>
            </div>
            <div class="col-lg-8">
                <div class="row">
                    <div class="col-md-9">
                        Действующие условия отсрочки платежа: <br>
                        Сумма: {{creditLimit | fixed}} рублей <br>
                        Срок: {{creditDays}} дней
                    </div>
                    <div class="col-md-3">
                        <a href="javascript:" @click="openSchedule()" style="font-size: 14px">Открыть PDF <img src="@/assets/img/pdf.png" alt="PDF" style="margin-left: 12px;"></a>
                        <a href="javascript:" @click="openScheduleHTML()" style="font-size: 14px">Открыть HTML <img src="@/assets/img/html.png" alt="HTML"></a>
                    </div>
                </div>

                <br/>
                <br/>

                <p>Сумма задолженности по плательщикам</p>

                <table class="table" style="font-size: 14px">
                    <thead>
                        <tr>
                            <td align="center">Плательщик</td>
                            <td align="center">В производстве</td>
                            <td align="center">В изготовленных</td>
                            <td align="center">Итого по плательщику</td>
                            <td align="center">Просрочено на {{today}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(payer, index) in array1" v-bind:key="index">
                            <td>{{payer[Object.keys(payer)[0]].id_pay_contragent}}</td>
                            <td align="center">{{array2[index].sumProd}}</td>
                            <td align="center">{{array2[index].sumManufactured | fixed}}</td>
                            <td align="center">{{array2[index].summa | fixed}}</td>
                            <td align="center">{{array2[index].dolg | fixed}}</td>
                        </tr>
                        <tr>
                            <td><b>ИТОГО</b></td>
                            <td align="center">{{allProd}}</td>
                            <td align="center">{{allManufactured | fixed}}</td>
                            <td align="center">-</td>
                            <td align="center" v-if="sum.RedEnd">{{sum.RedEnd | fixed}}</td>
                            <td align="center" v-else>0</td>
                        </tr>
                    </tbody>
                </table>

                <br>
                Полная сумма задолженности по всем плательщикам: <span v-if="sum.Full">{{sum.Full | fixed}}</span><span v-else>0</span> рублей<br><br>
                Полная просроченная задолженность на {{today}}: <span v-if="sum.RedEnd" class="red">{{sum.RedEnd | fixed}}</span><span v-else>0</span> рублей

                <br/>
                <br/>

                <div v-for="(payer, index) in array1" v-bind:key="index">
                    <table class="table scheduleTable">
                        <thead>
                        <tr>
                            <td align="center">Плательщик</td>
                            <td align="center">Номер<br>накладной</td>
                            <td align="center">Дата<br>отгрузки</td>
                            <td></td>
                            <td align="center" width="100px">Сумма по<br>накладной</td>
                            <td align="center">Платеж до</td>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(doc, index2) in payer" v-bind:key="index2">
                                <td>{{doc.id_pay_contragent}}</td>
                                <td><strong>{{doc.doc_full_no}}</strong></td>
                                <td>{{doc.date}}</td>
                                <td v-if="!doc.selected"><button type="button" class="btn btn-outline-primary" @click="counterChange(doc.payment_amount, 1, index, index2)"><i class="las la-plus"></i></button></td>
                                <td v-else><button type="button" class="btn btn-outline-primary" @click="counterChange(doc.payment_amount, -1, index, index2)"><i class="las la-minus"></i></button></td>
                                <td align="right"><span>{{doc.payment_amount | fixed}}</span></td>
                                <td align="right" v-if="doc.daysTo > 0">{{doc.payTo}}</td>
                                <td align="right" v-else>Просрочен!</td>
                            </tr>
                            <tr>
                                <td align="right" style="text-align: right !important;" colspan="4">Оплатить до {{Object.keys(array2[index])[0]}}:</td>
                                <td align="right" style="text-align: right !important;">{{array2[index][Object.keys(array2[index])[0]] | fixed}}</td>
                                <td align="left" style="text-align: left !important;">рублей</td>
                            </tr>
                            <tr style="height:30px;">
                                <td align="right" style="text-align: right !important;" colspan="4"><strong>Просрочено:</strong></td>
                                <td align="right" style="text-align: right !important;color: red;font-size: 110%; font-weight: bold;">{{array2[index].dolg | fixed}}</td>
                                <td align="left" style="text-align: left !important;">рублей</td>
                            </tr>
                            <tr style="height:30px;">
                                <td align="right" style="text-align: right !important;" colspan="4"><strong>Задолженность по плательщику:</strong></td>
                                <td align="right" style="text-align: right !important;"><strong>{{array2[index].summa | fixed}}</strong></td>
                                <td align="left" style="text-align: left !important;">рублей</td>
                            </tr>
                        </tbody>
                    </table>
                    <br><br>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import MenuComponent from '../components/AdditionalFeaturesMenu';
    import rm_katris from "../js/rm_katris/app";

    export default {
        name: "PaymentsSchedule",
        metaInfo: {
            title: 'График платежей',
            titleTemplate: '%s - sale.katris'
        },
        components: {
            MenuComponent
        },
        data() {
            return {
                session: this.$session.get('user'),
                array1: [],
                array2: [],
                creditDays: 0,
                creditLimit: 0,
                sum: [],
                counter: 0,
                today: 0,
                allProd: 0,
                allManufactured: 0
            }
        },
        filters: {
            fixed(value) {
                return parseFloat(value).toFixed(2)
            },
        },
        methods: {
            openSchedule: function() {
                rm_katris.makePost('katrisService', 'paymentSchedule', {'pdf': true, 'html': false}, null, function(response) {
                    if (!response.data.error) {
                        let newWindow = window.open("");
                        newWindow.document.write(
                            "<body style='margin:0'><iframe style='border: none;' width='100%' height='100%' src='data:application/pdf;base64, " +
                            encodeURI(response.data) + "'></iframe></body>"
                        )
                    } else {
                        alert('Ошибка получения файла.');
                    }
                });
            },
            openScheduleHTML: function() {
                rm_katris.makePost('katrisService', 'paymentSchedule', {'pdf': false, 'html': true}, null, function(response) {
                    if (!response.data.error) {
                        let newWindow = window.open("");
                        newWindow.document.body.innerHTML = response.data;
                    } else {
                        alert('Ошибка получения файла.');
                    }
                });
            },
            counterChange: function(sum, plusOrMinus, payer, doc) {
                // this.counter += sum * plusOrMinus;

                if (plusOrMinus == 1) {
                    this.counter += Number(sum);
                } else {
                    this.counter -= Number(sum);
                }

                let self = this;
                for (let payer2 in self.array1) {
                    // console.log(payer2, payer)
                    if (payer2 == payer) {
                        for (let doc2 in self.array1[payer]) {
                            if (doc2 == doc) {
                                // console.log(self.array1[payer][doc].selected)
                                self.array1[payer][doc].selected = !self.array1[payer][doc].selected;
                            }
                        }
                    }
                }

                alert("Сумма выбранных: " + this.counter);
            }
        },
        created() {
            let self = this;

            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0');
            let yyyy = today.getFullYear();
            self.today = dd + '.' + mm + '.' + yyyy;

            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');

            rm_katris.makePost('katrisService', 'paymentSchedule', {'pdf': false, 'html': false}, null, function(response) {
                // console.log(response)
                if (!response.data.error) {
                    response = JSON.parse(response.data);

                    console.log(response)

                    for (let payer in response.arr) {
                        response.arr2[payer].sumProd = 0;
                        response.arr2[payer].sumManufactured = 0;

                        for (let doc in response.arr[payer]) {
                            response.arr[payer][doc].selected = false;

                            if (response.arr[payer][doc].date == '-') {
                                response.arr2[payer].sumProd += parseFloat(response.arr[payer][doc].payment_amount);
                                self.allProd += parseFloat(response.arr[payer][doc].payment_amount);
                            } else {
                                response.arr2[payer].sumManufactured += parseFloat(response.arr[payer][doc].payment_amount);
                                self.allManufactured += parseFloat(response.arr[payer][doc].payment_amount);
                            }
                        }
                    }

                    self.array1 = response.arr;

                    self.array2 = response.arr2;



                    self.creditDays = response.kreditDays;
                    self.creditLimit = response.kreditLimit;
                    self.sum = response.sum;

                    console.log(self.array1, self.array2)
                }
            });
        }
    }
</script>

<style scoped>

</style>